import { Button, Col, Drawer, Image, Row, Tag, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import SpeechSwallowInspectionSummary from "./SpeechSwallowInspectionSummary";
import SpeechSwallowInitialInspectionForm from "./SpeechSwallowInitialInspectionForm";
import ClosePopup from "../../Doctor/InitialInspection/ClosePopup";
import { SpeechInitialContext } from "./SpeechSwallowInitialAssessmentProvider";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { getSpeechInspectionAPI } from "../../../../services/speech.services";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import EditIcon from "../../../ui/EditIcon";
import assessmentIcon from "../../../../assets/images/nurseIcons/assessment.svg";
import bedImg from "../../../../assets/images/patientIcons/bed.svg";
import { UserContext } from "../../../../context/UserContext";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import useQuery from "../../../../hooks/useQuery";
import dayjs from "dayjs";
import "../../Doctor/InitialInspection/InitialInspectionHeader.css";
import "../../summary.css";

const SpeechSwallowInitialInspection = ({
  patientData,
  editId,
  refreshPage,
}) => {
  const { userDetails } = useContext(UserContext);
  const [visible, setVisible] = useState(false);
  const { formData, setFormData } = useContext(SpeechInitialContext);
  const [initialRefresh, setInitialRefresh] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const isActive = useQuery()?.status === "current";

  const setInitialAssessmentRefresh = () => {
    setInitialRefresh((prev) => !prev);
  };

  const openEdit = async () => {
    if (editId) {
      try {
        const response = await getSpeechInspectionAPI(editId);
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    }
  };
  useEffect(() => {
    openEdit();
  }, [editId, initialRefresh]);
  const editRole = getCookie(Role) || userDetails?.currRole;
  const patientName = `${patientData?.admission?.patient?.first_name || ""} ${
    patientData?.admission?.patient?.last_name || ""
  }`.trim();

  return (
    <>
      {editRole === "Speech_Swallow_Therapist" ? (
        <>
          {" "}
          {editId ? (
            <Row
              gutter={[12, 8]}
              className="ia-summary-meta-row"
              style={{ marginTop: 0, alignItems: "center" }}
            >
              <Col span={24}>
                <div className="ia-summary-meta-bar">
                  {(formData?.submitted_by_first_name ||
                    formData?.submitted_by_last_name) && (
                    <Tag className="ia-summary-meta-tag ia-summary-meta-tag--submitted">
                      Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                      {formData?.submitted_by_last_name || ""}
                    </Tag>
                  )}
                  <div className="ia-summary-meta-bottom">
                    {formData?.updated_at && (
                      <Tag className="ia-summary-meta-tag ia-summary-meta-tag--updated">
                        Updated at:{" "}
                        {dayjs(formData?.updated_at).format(
                          "DD/MM/YYYY hh:mm A"
                        )}
                      </Tag>
                    )}
                    {isActive && (
                      <div className="ia-summary-meta-actions">
                        <Button
                          type="primary"
                          onClick={() => {
                            setActiveTab("1");
                            setVisible(true);
                            setAddModal(false);
                          }}
                          className={`${btnStyles.lgBtn} inv-btn`}
                          style={{ fontWeight: 500 }}
                        >
                          <EditIcon />
                          Edit
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col span={24} style={{ textAlign: "center" }}>
                <SpeechSwallowInspectionSummary
                  editId={editId}
                  docId={patientData?.doctor_intial_assessment}
                />
              </Col>
            </Row>
          ) : (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "80vh",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <NoDataPage
                  title={"Initial Assessment Not Yet Submitted "}
                  subtitle={isActive && "Kindly, upload an initial assessment here"}
                  image={assessmentIcon}
                />
                {isActive && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setActiveTab("1");
                      setVisible(true);
                      setAddModal(true);
                    }}
                    className={`${btnStyles.lgBtn} inv-btn`}
                  >
                    Initial Assessment Form
                  </Button>
                )}
              </Col>
            </Row>
          )}
          {visible && (
            <Drawer
              styles={{
                body: {
                  overflow: "hidden",
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingInline: 24,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                },
              }}
              open={visible}
              width="100%"
              title={
                <div className="ia-drawer-header">
                  <div className="ia-drawer-header__main">
                    <LeftOutlined
                      className="ia-drawer-header__back"
                      onClick={() => setConfirmModal(true)}
                    />
                    <div className="ia-drawer-header__identity">
                      <div className="ia-drawer-header__name-row">
                        <Typography.Text
                          className="ia-drawer-header__name"
                          ellipsis={{ tooltip: patientName }}
                        >
                          {patientName}
                        </Typography.Text>
                        {patientData?.admission?.bed?.bed_no && (
                          <Tag color="orange" className="ia-drawer-header__bed">
                            <Image src={bedImg} preview={false} width={12} />{" "}
                            {patientData?.admission?.bed?.bed_no}
                          </Tag>
                        )}
                      </div>
                      <div className="ia-drawer-header__meta">
                        <Tag className="ia-drawer-header__tag">
                          {patientData?.admission?.patient?.age}{" "}
                          {patientData?.admission?.patient?.gender}
                        </Tag>
                        <Tag className="ia-drawer-header__tag">
                          IP ID: {patientData?.admission?.ip_id}
                        </Tag>
                        {formData?.submitted_by_first_name && (
                          <Tag className="ia-drawer-header__tag">
                            Done by: {formData?.submitted_by_first_name}{" "}
                            {formData?.submitted_by_last_name || ""}
                          </Tag>
                        )}
                        <Tag className="ia-drawer-header__tag">
                          {dayjs(formData?.updated_at || new Date()).format(
                            "DD/MM/YYYY"
                          )}
                        </Tag>
                      </div>
                    </div>
                  </div>
                </div>
              }
              footer={null}
              onClose={() => setVisible(false)}
              closeIcon={null}
              keyboard={false}
            >
              <SpeechSwallowInitialInspectionForm
                visible={visible}
                setVisible={setVisible}
                refreshPage={refreshPage}
                initialRefresh={setInitialAssessmentRefresh}
                editId={editId}
                patientData={patientData}
                setConfirmModal={setConfirmModal}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />

              {confirmModal && (
                <ClosePopup
                  open={confirmModal}
                  setOpen={setConfirmModal}
                  setVisible={setVisible}
                  setActiveTab={setActiveTab}
                />
              )}
            </Drawer>
          )}
        </>
      ) : (
        <Col span={24} style={{ textAlign: "center" }}>
          {editId ? (
            <SpeechSwallowInspectionSummary
              editId={editId}
              docId={patientData?.doctor_intial_assessment}
            />
          ) : (
            <NoDataPage
              title={
                "Speech and Swallow Therapist Initial Assessment Not Yet Submitted "
              }
              image={assessmentIcon}
            />
          )}
        </Col>
      )}
    </>
  );
};

export default SpeechSwallowInitialInspection;
